export enum WallPosition {
  SideWall = 'sidewall',
  GableEnd = 'gableend',
  PorchGableEnd = 'porch-gableend',
  RoofSurface = 'roof-surface',
}
